import React, { useEffect, useState } from 'react';
import { ApiCenter } from '../../api/ApiCenter';
import { nanoid } from 'nanoid';
import classes from './style/EducationComponent.module.css';
import { Link } from 'react-router-dom';
import { RoleComponentRender, UI_Pagination } from '../../../Core/Core';
import { Roles } from '../../../types/Types';
import EducationCard from './EducationCard/EducationCard';
import { Button, Form, Select } from 'antd';
import { ICategories } from '../../../types/TestType';
const EducationComponent = () => {
  const [data, setData] = useState<any>([]);
  const [form] = Form.useForm();
  const Apistart = new ApiCenter();
  const [activeButton, setActiveButton] = useState<string>('all');
  const { HRNYA, SUPER_ADMIN, ADMIN } = Roles;
  const cardsPerPage = 12;

  const [currentPage, setCurrentPage] = React.useState(1);
  const totalPages = Math.ceil(data?.themes?.length / cardsPerPage);

  const paginatedDepartments = data?.themes?.slice(
    (currentPage - 1) * cardsPerPage,
    currentPage * cardsPerPage
  );

  const [filterThemes, setFilterThemes] = useState<{
    category_id: number;
    isDraft: boolean | null;
  }>({ category_id: 1, isDraft: null });
  function constructThemeLink() {
    const baseApiUrl = 'hr/theme';
    let apiUrl = baseApiUrl;

    if (filterThemes.category_id !== 1) {
      apiUrl += `?category_id=${filterThemes.category_id}`;
    }

    if (filterThemes.isDraft !== null) {
      apiUrl += apiUrl.includes('?')
        ? `&is_draft=${filterThemes.isDraft}`
        : `?is_draft=${filterThemes.isDraft}`;
    }
    return apiUrl;
  }
  const fetchData = async () => {
    try {
      const response = await Apistart.GET_API(constructThemeLink(), 'GET');
      if (response.success) {
        setData(response.data);
      } else {
        setData(false);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      setData(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [filterThemes]);
  const handlePageChange = (newPage: number | null, decr?: boolean, increm?: boolean) => {
    if (newPage) {
      setCurrentPage(newPage);
    }
    if (decr) {
      setCurrentPage((prev) => (prev -= 1));
    }
    if (increm) {
      setCurrentPage((prev) => (prev += 1));
    }
  };
  const themeDelete = async (e: React.MouseEvent<HTMLElement, MouseEvent>, id: number) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const response = await Apistart.GET_API(`hr/theme/${id}`, 'DELETE');
      if (response.success) {
        fetchData();
      } else {
        setData(false);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      setData(false);
    }
  };
  const handleChange = (value: number) => {
    setFilterThemes((prev) => ({ ...prev, category_id: value }));
  };
  const handleModeChange = (value: string) => {
    setFilterThemes((prev) => ({ ...prev, isDraft: value === 'draft' }));
    setActiveButton(value);
  };
  interface IAttestationsButton {
    attestation: {
      id: number;
      user_id: number;
      points: number;
      questions_count: number;
      is_passed: boolean;
      complete_date: Date | null;
    } | null;
  }
  const AttestationsButton: React.FC<IAttestationsButton> = (props) => {
    const { attestation } = props;

    if (attestation?.complete_date === null && attestation !== null) {
      return (
        <Button type="primary">
          <Link to={'attestation'}>Начать аттестацию</Link>
        </Button>
      );
    }
    return null;
  };
  return (
    <div style={{ paddingTop: '0' }}>
      <div className={classes.HeaderTitle}>
        <div>Обучение</div>
        <div>
          <AttestationsButton attestation={data.attestation} />
          <RoleComponentRender roles={[HRNYA, SUPER_ADMIN, ADMIN]}>
            <Button style={{ marginLeft: 10 }} type="primary">
              <Link style={{ color: 'white' }} to={`creating-theme`}>
                Создать новую тему
              </Link>
            </Button>
          </RoleComponentRender>
        </div>
      </div>
      <div>
        <Form form={form} autoComplete="off" layout="vertical">
          {data?.categories && (
            <Form.Item style={{ width: 450 }} label="Категория" name="category_id" initialValue={1}>
              <Select onChange={handleChange} placeholder="Категория урока">
                <Select.Option value={1}>Все</Select.Option>
                {data.categories.map((item: ICategories) => {
                  return (
                    <Select.Option value={item?.id} key={item?.id}>
                      {item?.title}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
          )}
        </Form>
      </div>
      <RoleComponentRender roles={[HRNYA, SUPER_ADMIN, ADMIN]}>
        <div className={classes.buttonWrapper}>
          <Button
            style={{
              border: activeButton === 'all' ? '1px solid #CCC' : 'none',
              backgroundColor: 'none',
              padding: '0 30px 0 30px',
            }}
            onClick={() => handleModeChange('all')}
          >
            Все
          </Button>
          <Button
            style={{
              border: activeButton === 'save' ? '1px solid #CCC' : 'none',
              backgroundColor: 'none',
            }}
            onClick={() => handleModeChange('save')}
          >
            Сохраненные
          </Button>
          <Button
            style={{
              border: activeButton === 'draft' ? '1px solid #CCC' : 'none',
              backgroundColor: 'none',
            }}
            onClick={() => handleModeChange('draft')}
          >
            Черновики
          </Button>
        </div>
      </RoleComponentRender>
      {/* <div className={classes.buttonWrapper}>
        <Radio.Group
          onChange={handleModeChange}
          value={filterThemes.isDraft}
          style={{ marginBottom: 8 }}
        >
          <Radio.Button value={false} style={{ border: 'none' }}>
            Сохраненные
          </Radio.Button>
          <Radio.Button value={true} style={{ border: 'none' }}>
            Черновики
          </Radio.Button>
        </Radio.Group>
      </div> */}

      <div className={classes.Wrapper}>
        {paginatedDepartments?.map((theme: any) => {
          const id = nanoid();
          return (
            <div key={id} className={classes.card}>
              <EducationCard
                is_visible={theme.is_visible}
                title={theme.title}
                lessons_count={theme.lessons_count}
                test={theme.test}
                id={theme.id}
                themeDelete={themeDelete}
              />
            </div>
          );
        })}
      </div>
      {totalPages > 1 && (
        <UI_Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default EducationComponent;
